import {mapGetters} from 'vuex'
import * as GoogleMapsMutationTypes from '@/store/modules/googleMaps/mutation-types'

const mixin = {
    methods: {
        googleMapsInitialize() {
            return new Promise((resolve, reject) => {
                if (this.isInitialized) {
                    return resolve();
                }

                if (!this.initializationPromise) {
                    let promise = new Promise((resolve1, reject1) => {
                        let callback = 'googleMapInitializationCallback';

                        window[callback] = () => {
                            this.$store.commit(`googleMaps/${GoogleMapsMutationTypes.INITIALIZED}`, true);
                            resolve1();
                        };

                        let key = "AIzaSyDenL0PBZS_slHcVgHgJALfKYXR_xED5rw";
                        let asyncUrl = `https://maps.googleapis.com/maps/api/js?key=${key}&language=en&region=en-US&libraries=places,drawing&callback=${callback}`;

                        let script = document.createElement('script');
                        script.src = asyncUrl;
                        script.setAttribute('async', '');
                        script.setAttribute('defer', '');
                        document.body.appendChild(script);
                    });

                    this.$store.commit(`googleMaps/${GoogleMapsMutationTypes.INITIALIZATION_PROMISE}`, promise);
                }

                this.initializationPromise.then(() => {
                    resolve();
                });
            });
        },
        googleMapsAutocompleteService() {
            return this.googleMapsInitialize()
                .then(() => {
                    return new google.maps.places.AutocompleteService();
                });
        },
        googleMapsPlacesService() {
            return this.googleMapsInitialize()
                .then(() => {
                    return new google.maps.places.PlacesService(document.createElement("div"));
                });
        },
        googleMapsPlacePredictions(address) {
            let placeId = undefined;

            return this.googleMapsAutocompleteService()
                .then((service) => {
                    return new Promise((resolve, reject) => {
                        service.getPlacePredictions({
                                'input': address
                            },
                            (list, status) => {
                                if (list && list.length > 0) {
                                    placeId = list[0].place_id;
                                    resolve();
                                } else {
                                    reject();
                                }
                            });
                    })
                })
                .then(() => {
                    return this.googleMapsPlacesService();
                })
                .then((service) => {
                    return new Promise((resolve, reject) => {
                        service.getDetails({
                            placeId: placeId
                        }, (result) => {
                            resolve(result);
                        });
                    });
                });
        }
    },
    mounted() {
        this.googleMapsInitialize();
    },
    computed: {
        ...mapGetters('googleMaps', [
            'isInitialized',
            'initializationPromise'
        ])
    }
};

export default mixin;
